import { apiRequest, apiUpload } from './client'
import type { Paginated, User } from './types'

export const usersApi = {
  list: (params: { page?: number; pageSize?: number; search?: string; includeInactive?: boolean } = {}) =>
    apiRequest<Paginated<User>>('/users', { query: params }),

  create: (input: { username: string; displayName: string; email?: string; password: string; roleIds: string[] }) =>
    apiRequest<{ data: User }>('/users', { method: 'POST', body: input }),

  update: (id: string, input: { displayName?: string; email?: string; avatarUrl?: string }) =>
    apiRequest<{ data: User }>(`/users/${id}`, { method: 'PATCH', body: input }),

  updateOwnProfile: (input: { displayName?: string; email?: string; avatarUrl?: string; status?: string }) =>
    apiRequest<{ data: User }>('/users/me', { method: 'PATCH', body: input }),

  uploadAvatar: (file: File) => apiUpload<{ data: User }>('/users/me/avatar', file),

  assignRoles: (id: string, roleIds: string[]) =>
    apiRequest<{ data: User }>(`/users/${id}/roles`, { method: 'PATCH', body: { roleIds } }),

  deactivate: (id: string) => apiRequest<{ data: { success: boolean } }>(`/users/${id}/deactivate`, { method: 'POST' }),

  reactivate: (id: string) => apiRequest<{ data: { success: boolean } }>(`/users/${id}/reactivate`, { method: 'POST' }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/users/${id}`, { method: 'DELETE' }),

  resetPassword: (id: string, newPassword: string) =>
    apiRequest<{ data: { success: boolean } }>(`/users/${id}/reset-password`, { method: 'POST', body: { newPassword } }),
}
